import ApiCrud from "./api-crud";
import apiCaller from "./api-caller";

class UsuarioService extends ApiCrud {
  resource = "usuarios";
  primaryKey = "idusuario";

  // El backend toma el usuario del token: no se envía ningún id.
  changePassword({ currentPassword, newPassword }) {
    return apiCaller
      .post(`/${this.resource}/changePassword`, {
        currentPassword,
        newPassword,
      })
      .then((response) => {
        // api-caller no lanza excepción ante 4xx: devuelve la respuesta.
        if (!response || response.status < 200 || response.status > 299) {
          throw (
            response?.data?.error ||
            response?.data?.message ||
            "No se ha podido cambiar la contraseña"
          );
        }

        return response.data;
      });
  }

  updateLanguage(record) {
    return apiCaller
      .post(`/${this.resource}/updateLanguage`, record)
      .then((response) => {
        return response.data;
      });
  }
}

export default new UsuarioService();
